import { Box, Grid2 } from '@mui/material';
import React from 'react';
import CustomButton from '@ui-components/Button/CustomButton';
import CustomDialog from '@ui-components/Dialog/CustomDialog';
import CustomDialogActions from '@ui-components/Dialog/CustomDialogActions';
import CustomDialogContent from '@ui-components/Dialog/CustomDialogContent';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import ConsultCompleteIcon from '@assets/images/ConsultComplete-pop.svg';

type RestartConfirmDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const RestartConfirmDialog: React.FC<RestartConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <CustomDialog id="dialogRestartConfirm" open={open} onClose={onClose}>
      <CustomDialogContent className="dialog-width">
        <Box className="pb-12">
          <ConsultCompleteIcon />
        </Box>
        <Box className="pb-4">
          <CustomTypography id="restart-title-popup" variant="subtitle1">
            Restart Call?
          </CustomTypography>
        </Box>
        <Box>
          <CustomTypography
            id="restart-message-popup"
            variant="body3"
            className="pb-4"
          >
            Are you sure you want to restart the call?
          </CustomTypography>

          <CustomTypography id="restart-message2-popup" variant="body3">
            If you are currently on an ongoing call, clicking Confirm will end
            the current call and start a new one. Do you want to proceed?
          </CustomTypography>
        </Box>
      </CustomDialogContent>

      <CustomDialogActions>
        <Grid2 container>
          <Grid2 className="mr-8">
            <CustomButton
              id="btnRestartCancel"
              color="error"
              variant="outlined"
              onClick={onClose}
            >
              Cancel
            </CustomButton>
          </Grid2>
          <Grid2>
            <CustomButton
              id="btnRestartConfirm"
              color="primary"
              variant="contained"
              onClick={onConfirm}
            >
              Confirm
            </CustomButton>
          </Grid2>
        </Grid2>
      </CustomDialogActions>
    </CustomDialog>
  );
};

export default RestartConfirmDialog;
